'use strict';

// // infact = inferno + react

exports.React = require('react');
exports.ReactDOM = require('react-dom');
exports.Component = exports.React.Component;


//////////////////
// WEBPACK FOOTER
// ./~/pigeon-overlay/lib/react/infact.js
// module id = 1729
// module chunks = 0